import * as React from 'react';
import { WpContext } from './buttonWhatssapContext';

export const WpProvider = ({ children }: { children: React.ReactNode }) => {
  const state = React.useState('light');

  return <WpContext.Provider value={state}>{children}</WpContext.Provider>;
};
